import { createContext } from 'react';

export const MusaicDataContext = createContext();

export const MusaicDataProvider = MusaicDataContext.Provider;
export const MusaicDataConsumer = MusaicDataContext.Consumer;
